import { restoreAbandonedCart } from 'actions/CheckoutActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { timeNowInSecond } from 'lib/time'
import uuidV4 from 'lib/uuidV4'
import { useEffect } from 'react'
import { getLatestAbandonedCart } from 'selectors/recomendations/highIntentSelectors'

const maybeUpdateTransactionKey = (cartState?: App.AbandonedCartRecommendation): App.AbandonedCartRecommendation | undefined => {
  const timestamp = cartState?.creationTime
  const isOlderThan30Min = !timestamp || (timeNowInSecond() - timestamp > 30 * 60)
  if (cartState?.items?.length) {
    if (isOlderThan30Min) {
      return {
        ...cartState,
        transactionKey: uuidV4(),
      }
    }
    return cartState
  }
}

export function useRestoreAbandonedCartState(isAbandonedCartEnabled: boolean) {
  const dispatch = useAppDispatch()
  const isSpoofed = useAppSelector(state => state.auth.account.isSpoofed)
  const lereCartState: App.AbandonedCartRecommendation | undefined = useAppSelector(getLatestAbandonedCart)

  useEffect(() => {
    if (isSpoofed || !isAbandonedCartEnabled) { return }

    const cart = maybeUpdateTransactionKey(lereCartState)

    if (cart) {
      dispatch(restoreAbandonedCart(cart))
    }
  }, [dispatch, lereCartState, isAbandonedCartEnabled, isSpoofed])
}
